import { AllWebpartFunctions, Merge } from "../../Bfs.Web.Portale/WebPart.fs.js";
import { Msg as Msg_1, Model, Page } from "./Admin/Admin/Types.fs.js";
import { Part } from "./Admin/Admin/WebPart.fs.js";
import { Cmd_map } from "../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Model as Model_1, Msg } from "../../Bfs.Web.Portale/Types.fs.js";
import { map } from "../fable_modules/fable-library-js.4.19.0/Option.js";
import { Msg as Msg_2, Model as Model_2, Page as Page_1 } from "./Admin/AdminFaq/Types.fs.js";
import { Part as Part_1 } from "./Admin/AdminFaq/WebPart.fs.js";
import { Msg as Msg_3, Model as Model_3, Page as Page_2 } from "./Admin/AdminNews/Types.fs.js";
import { Part as Part_2 } from "./Admin/AdminNews/WebPart.fs.js";
import { Msg as Msg_4, Model as Model_4, Page as Page_3 } from "./Admin/AdminFile/Types.fs.js";
import { Part as Part_3 } from "./Admin/AdminFile/WebPart.fs.js";
import { Msg as Msg_5, Model as Model_5, Page as Page_4 } from "./Admin/AdminText/Types.fs.js";
import { Part as Part_4 } from "./Admin/AdminText/WebPart.fs.js";
import { Msg as Msg_6, Model as Model_6, Page as Page_5 } from "./Admin/AdminBanner/Types.fs.js";
import { Part as Part_5 } from "./Admin/AdminBanner/WebPart.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.19.0/List.js";
import { Msg as Msg_7, Model as Model_7, Page as Page_6 } from "./User/News/Types.fs.js";
import { Part as Part_6 } from "./User/News/WebPart.fs.js";
import { Msg as Msg_8, Model as Model_8, Page as Page_7 } from "./User/Files/Types.fs.js";
import { Part as Part_7 } from "./User/Files/WebPart.fs.js";
import { Msg as Msg_9, Model as Model_9, Page as Page_8 } from "./User/Tickets/Types.fs.js";
import { Part as Part_8 } from "./User/Tickets/WebPart.fs.js";
import { Msg as Msg_10, Model as Model_10, Page as Page_9 } from "./User/Faq/Types.fs.js";
import { Part as Part_9 } from "./User/Faq/WebPart.fs.js";
import { Msg as Msg_11, Model as Model_11, Page as Page_10 } from "./User/Help/Types.fs.js";
import { Part as Part_10 } from "./User/Help/WebPart.fs.js";
import { Msg as Msg_12, Model as Model_12, Page as Page_11 } from "./User/Dta/Types.fs.js";
import { Part as Part_11 } from "./User/Dta/WebPart.fs.js";
import { Msg as Msg_13, Model as Model_13, Page as Page_12 } from "./User/Sendungen/Types.fs.js";
import { Part as Part_12 } from "./User/Sendungen/WebPart.fs.js";
import { Msg as Msg_14, Model as Model_14, Page as Page_13 } from "./User/Verrechnungen/Types.fs.js";
import { Part as Part_13 } from "./User/Verrechnungen/WebPart.fs.js";
import { Msg as Msg_15, Model as Model_15, Page as Page_14 } from "./User/UserManagement/Types.fs.js";
import { Part as Part_14 } from "./User/UserManagement/WebPart.fs.js";
import { Msg as Msg_16, Model as Model_16, Page as Page_15 } from "./User/Home/Types.fs.js";
import { Part as Part_15 } from "./User/Home/WebPart.fs.js";
import { DashboardPage } from "./User/DashBoardPage.fs.js";
import { Msg as Msg_17, Model as Model_17 } from "./User/Dashboard/Types.fs.js";
import { Part as Part_16 } from "./User/Dashboard/Webpart.fs.js";
import { Msg as Msg_18, Model as Model_18, Page as Page_16 } from "./User/Zahlungen/Types.fs.js";
import { Part as Part_17 } from "./User/Zahlungen/WebPart.fs.js";
import { Msg as Msg_19, Model as Model_19, Page as Page_17 } from "./User/LetzteSendung/Types.fs.js";
import { Part as Part_18 } from "./User/LetzteSendung/WebPart.fs.js";
import { Msg as Msg_20, Model as Model_20, Page as Page_18 } from "./User/LetzterBelegeingang/Types.fs.js";
import { Part as Part_19 } from "./User/LetzterBelegeingang/WebPart.fs.js";
import { Msg as Msg_21, Model as Model_21, Page as Page_19 } from "./User/DokumentenDepot/Types.fs.js";
import { Part as Part_20 } from "./User/DokumentenDepot/WebPart.fs.js";
import { Msg as Msg_22, Model as Model_22, Page as Page_20 } from "./User/QuickFinder/Types.fs.js";
import { Part as Part_21 } from "./User/QuickFinder/WebPart.fs.js";
import { Msg as Msg_23, Model as Model_23, Page as Page_21 } from "./User/Settings/Types.fs.js";
import { Part as Part_22 } from "./User/Settings/WebPart.fs.js";
import { Part as Part_23 } from "./User/Beratungstermin/WebPart.fs.js";
import { Model as Model_24, Page as Page_22 } from "./User/Beratungstermin/Types.fs.js";
import { Msg as Msg_24, Model as Model_25, Page as Page_23 } from "./User/ApiToken/Types.fs.js";
import { Part as Part_24 } from "./User/ApiToken/WebPart.fs.js";
import { Msg as Msg_25, Model as Model_26, Page as Page_24 } from "./StaticPages/Types.fs.js";
import { Part as Part_25 } from "./StaticPages/WebPart.fs.js";
import { Msg as Msg_26, Model as Model_27, Page as Page_25 } from "./Login/Types.fs.js";
import { Part as Part_26 } from "./Login/WebPart.fs.js";
import { Msg as Msg_27, Model as Model_28, Page as Page_26 } from "./Profile/Types.fs.js";
import { Part as Part_27 } from "./Profile/WebPart.fs.js";
import { Msg as Msg_28, Model as Model_29, Page as Page_27 } from "./Notifications/Types.fs.js";
import { Part as Part_28 } from "./Notifications/WebPart.fs.js";
import { Msg as Msg_29, Model as Model_30, Page as Page_28 } from "./Password/Types.fs.js";
import { Part as Part_29 } from "./Password/WebPart.fs.js";
import { Msg as Msg_30, Model as Model_31, Page as Page_29 } from "./Sepa/Types.fs.js";
import { Part as Part_30 } from "./Sepa/WebPart.fs.js";

const AllAdminParts = Merge(ofArray([new AllWebpartFunctions((page, userSession, model) => {
    const page_1 = page;
    const model_1 = model;
    if (page_1 instanceof Page) {
        const oldModel = (model_1.PageModel instanceof Model) ? model_1.PageModel : undefined;
        const patternInput = Part.Init(page_1, userSession, oldModel);
        return [patternInput[0], Cmd_map((x) => (new Msg(1, [x])), patternInput[1])];
    }
    else {
        return undefined;
    }
}, (msg, globalmodel) => {
    const msg_1 = msg;
    const globalmodel_1 = globalmodel;
    if ((globalmodel_1.PageModel instanceof Model) && (msg_1 instanceof Msg_1)) {
        const pageModel = globalmodel_1.PageModel;
        const patternInput_1 = Part.Update(msg_1, pageModel);
        return [new Model_1(globalmodel_1.Page, patternInput_1[0], globalmodel_1.User, globalmodel_1.VideoOverlayVimeoId, globalmodel_1.MessageBox, globalmodel_1.IsBurgerMenuOpen, globalmodel_1.IsNotificationMenuOpen), Cmd_map((x_1) => (new Msg(1, [x_1])), patternInput_1[1])];
    }
    else {
        return undefined;
    }
}, (model_1_1, dispatch, navigateTo) => {
    const model_2 = model_1_1;
    return (model_2.PageModel instanceof Model) ? Part.View(model_2.PageModel, (msg_2) => {
        dispatch(new Msg(1, [msg_2]));
    }, navigateTo) : undefined;
}, (model_2_1) => {
    const model_3 = model_2_1;
    return (model_3.PageModel instanceof Model) ? Part.GetHeader(model_3.PageModel) : undefined;
}, (msg_1_1) => {
    const msg_3 = msg_1_1;
    return (msg_3 instanceof Msg_1) ? Part.GetGlobalMsg(msg_3) : undefined;
}, (segments) => map((p) => p, Part.ParseUrl(segments)), (page_1_1) => {
    const page_2 = page_1_1;
    return (page_2 instanceof Page) ? Part.BuildUrl(page_2) : undefined;
}), new AllWebpartFunctions((page_3, userSession_2, model_4) => {
    const page_4 = page_3;
    const model_5 = model_4;
    if (page_4 instanceof Page_1) {
        const oldModel_1 = (model_5.PageModel instanceof Model_2) ? model_5.PageModel : undefined;
        const patternInput_2 = Part_1.Init(page_4, userSession_2, oldModel_1);
        return [patternInput_2[0], Cmd_map((x_2) => (new Msg(1, [x_2])), patternInput_2[1])];
    }
    else {
        return undefined;
    }
}, (msg_4, globalmodel_2) => {
    const msg_5 = msg_4;
    const globalmodel_3 = globalmodel_2;
    if ((globalmodel_3.PageModel instanceof Model_2) && (msg_5 instanceof Msg_2)) {
        const pageModel_1 = globalmodel_3.PageModel;
        const patternInput_3 = Part_1.Update(msg_5, pageModel_1);
        return [new Model_1(globalmodel_3.Page, patternInput_3[0], globalmodel_3.User, globalmodel_3.VideoOverlayVimeoId, globalmodel_3.MessageBox, globalmodel_3.IsBurgerMenuOpen, globalmodel_3.IsNotificationMenuOpen), Cmd_map((x_3) => (new Msg(1, [x_3])), patternInput_3[1])];
    }
    else {
        return undefined;
    }
}, (model_1_3, dispatch_2, navigateTo_2) => {
    const model_6 = model_1_3;
    return (model_6.PageModel instanceof Model_2) ? Part_1.View(model_6.PageModel, (msg_6) => {
        dispatch_2(new Msg(1, [msg_6]));
    }, navigateTo_2) : undefined;
}, (model_2_2) => {
    const model_7 = model_2_2;
    return (model_7.PageModel instanceof Model_2) ? Part_1.GetHeader(model_7.PageModel) : undefined;
}, (msg_1_2) => {
    const msg_7 = msg_1_2;
    return (msg_7 instanceof Msg_2) ? Part_1.GetGlobalMsg(msg_7) : undefined;
}, (segments_2) => map((p_1) => p_1, Part_1.ParseUrl(segments_2)), (page_1_2) => {
    const page_5 = page_1_2;
    return (page_5 instanceof Page_1) ? Part_1.BuildUrl(page_5) : undefined;
}), new AllWebpartFunctions((page_6, userSession_4, model_8) => {
    const page_7 = page_6;
    const model_9 = model_8;
    if (page_7 instanceof Page_2) {
        const oldModel_2 = (model_9.PageModel instanceof Model_3) ? model_9.PageModel : undefined;
        const patternInput_4 = Part_2.Init(page_7, userSession_4, oldModel_2);
        return [patternInput_4[0], Cmd_map((x_4) => (new Msg(1, [x_4])), patternInput_4[1])];
    }
    else {
        return undefined;
    }
}, (msg_8, globalmodel_4) => {
    const msg_9 = msg_8;
    const globalmodel_5 = globalmodel_4;
    if ((globalmodel_5.PageModel instanceof Model_3) && (msg_9 instanceof Msg_3)) {
        const pageModel_2 = globalmodel_5.PageModel;
        const patternInput_5 = Part_2.Update(msg_9, pageModel_2);
        return [new Model_1(globalmodel_5.Page, patternInput_5[0], globalmodel_5.User, globalmodel_5.VideoOverlayVimeoId, globalmodel_5.MessageBox, globalmodel_5.IsBurgerMenuOpen, globalmodel_5.IsNotificationMenuOpen), Cmd_map((x_5) => (new Msg(1, [x_5])), patternInput_5[1])];
    }
    else {
        return undefined;
    }
}, (model_1_5, dispatch_4, navigateTo_4) => {
    const model_10 = model_1_5;
    return (model_10.PageModel instanceof Model_3) ? Part_2.View(model_10.PageModel, (msg_10) => {
        dispatch_4(new Msg(1, [msg_10]));
    }, navigateTo_4) : undefined;
}, (model_2_3) => {
    const model_11 = model_2_3;
    return (model_11.PageModel instanceof Model_3) ? Part_2.GetHeader(model_11.PageModel) : undefined;
}, (msg_1_3) => {
    const msg_11 = msg_1_3;
    return (msg_11 instanceof Msg_3) ? Part_2.GetGlobalMsg(msg_11) : undefined;
}, (segments_4) => map((p_2) => p_2, Part_2.ParseUrl(segments_4)), (page_1_3) => {
    const page_8 = page_1_3;
    return (page_8 instanceof Page_2) ? Part_2.BuildUrl(page_8) : undefined;
}), new AllWebpartFunctions((page_9, userSession_6, model_12) => {
    const page_10 = page_9;
    const model_13 = model_12;
    if (page_10 instanceof Page_3) {
        const oldModel_3 = (model_13.PageModel instanceof Model_4) ? model_13.PageModel : undefined;
        const patternInput_6 = Part_3.Init(page_10, userSession_6, oldModel_3);
        return [patternInput_6[0], Cmd_map((x_6) => (new Msg(1, [x_6])), patternInput_6[1])];
    }
    else {
        return undefined;
    }
}, (msg_12, globalmodel_6) => {
    const msg_13 = msg_12;
    const globalmodel_7 = globalmodel_6;
    if ((globalmodel_7.PageModel instanceof Model_4) && (msg_13 instanceof Msg_4)) {
        const pageModel_3 = globalmodel_7.PageModel;
        const patternInput_7 = Part_3.Update(msg_13, pageModel_3);
        return [new Model_1(globalmodel_7.Page, patternInput_7[0], globalmodel_7.User, globalmodel_7.VideoOverlayVimeoId, globalmodel_7.MessageBox, globalmodel_7.IsBurgerMenuOpen, globalmodel_7.IsNotificationMenuOpen), Cmd_map((x_7) => (new Msg(1, [x_7])), patternInput_7[1])];
    }
    else {
        return undefined;
    }
}, (model_1_7, dispatch_6, navigateTo_6) => {
    const model_14 = model_1_7;
    return (model_14.PageModel instanceof Model_4) ? Part_3.View(model_14.PageModel, (msg_14) => {
        dispatch_6(new Msg(1, [msg_14]));
    }, navigateTo_6) : undefined;
}, (model_2_4) => {
    const model_15 = model_2_4;
    return (model_15.PageModel instanceof Model_4) ? Part_3.GetHeader(model_15.PageModel) : undefined;
}, (msg_1_4) => {
    const msg_15 = msg_1_4;
    return (msg_15 instanceof Msg_4) ? Part_3.GetGlobalMsg(msg_15) : undefined;
}, (segments_6) => map((p_3) => p_3, Part_3.ParseUrl(segments_6)), (page_1_4) => {
    const page_11 = page_1_4;
    return (page_11 instanceof Page_3) ? Part_3.BuildUrl(page_11) : undefined;
}), new AllWebpartFunctions((page_12, userSession_8, model_16) => {
    const page_13 = page_12;
    const model_17 = model_16;
    if (page_13 instanceof Page_4) {
        const oldModel_4 = (model_17.PageModel instanceof Model_5) ? model_17.PageModel : undefined;
        const patternInput_8 = Part_4.Init(page_13, userSession_8, oldModel_4);
        return [patternInput_8[0], Cmd_map((x_8) => (new Msg(1, [x_8])), patternInput_8[1])];
    }
    else {
        return undefined;
    }
}, (msg_16, globalmodel_8) => {
    const msg_17 = msg_16;
    const globalmodel_9 = globalmodel_8;
    if ((globalmodel_9.PageModel instanceof Model_5) && (msg_17 instanceof Msg_5)) {
        const pageModel_4 = globalmodel_9.PageModel;
        const patternInput_9 = Part_4.Update(msg_17, pageModel_4);
        return [new Model_1(globalmodel_9.Page, patternInput_9[0], globalmodel_9.User, globalmodel_9.VideoOverlayVimeoId, globalmodel_9.MessageBox, globalmodel_9.IsBurgerMenuOpen, globalmodel_9.IsNotificationMenuOpen), Cmd_map((x_9) => (new Msg(1, [x_9])), patternInput_9[1])];
    }
    else {
        return undefined;
    }
}, (model_1_9, dispatch_8, navigateTo_8) => {
    const model_18 = model_1_9;
    return (model_18.PageModel instanceof Model_5) ? Part_4.View(model_18.PageModel, (msg_18) => {
        dispatch_8(new Msg(1, [msg_18]));
    }, navigateTo_8) : undefined;
}, (model_2_5) => {
    const model_19 = model_2_5;
    return (model_19.PageModel instanceof Model_5) ? Part_4.GetHeader(model_19.PageModel) : undefined;
}, (msg_1_5) => {
    const msg_19 = msg_1_5;
    return (msg_19 instanceof Msg_5) ? Part_4.GetGlobalMsg(msg_19) : undefined;
}, (segments_8) => map((p_4) => p_4, Part_4.ParseUrl(segments_8)), (page_1_5) => {
    const page_14 = page_1_5;
    return (page_14 instanceof Page_4) ? Part_4.BuildUrl(page_14) : undefined;
}), new AllWebpartFunctions((page_15, userSession_10, model_20) => {
    const page_16 = page_15;
    const model_21 = model_20;
    if (page_16 instanceof Page_5) {
        const oldModel_5 = (model_21.PageModel instanceof Model_6) ? model_21.PageModel : undefined;
        const patternInput_10 = Part_5.Init(page_16, userSession_10, oldModel_5);
        return [patternInput_10[0], Cmd_map((x_10) => (new Msg(1, [x_10])), patternInput_10[1])];
    }
    else {
        return undefined;
    }
}, (msg_20, globalmodel_10) => {
    const msg_21 = msg_20;
    const globalmodel_11 = globalmodel_10;
    if ((globalmodel_11.PageModel instanceof Model_6) && (msg_21 instanceof Msg_6)) {
        const pageModel_5 = globalmodel_11.PageModel;
        const patternInput_11 = Part_5.Update(msg_21, pageModel_5);
        return [new Model_1(globalmodel_11.Page, patternInput_11[0], globalmodel_11.User, globalmodel_11.VideoOverlayVimeoId, globalmodel_11.MessageBox, globalmodel_11.IsBurgerMenuOpen, globalmodel_11.IsNotificationMenuOpen), Cmd_map((x_11) => (new Msg(1, [x_11])), patternInput_11[1])];
    }
    else {
        return undefined;
    }
}, (model_1_11, dispatch_10, navigateTo_10) => {
    const model_22 = model_1_11;
    return (model_22.PageModel instanceof Model_6) ? Part_5.View(model_22.PageModel, (msg_22) => {
        dispatch_10(new Msg(1, [msg_22]));
    }, navigateTo_10) : undefined;
}, (model_2_6) => {
    const model_23 = model_2_6;
    return (model_23.PageModel instanceof Model_6) ? Part_5.GetHeader(model_23.PageModel) : undefined;
}, (msg_1_6) => {
    const msg_23 = msg_1_6;
    return (msg_23 instanceof Msg_6) ? Part_5.GetGlobalMsg(msg_23) : undefined;
}, (segments_10) => map((p_5) => p_5, Part_5.ParseUrl(segments_10)), (page_1_6) => {
    const page_17 = page_1_6;
    return (page_17 instanceof Page_5) ? Part_5.BuildUrl(page_17) : undefined;
})]));

const AllUserParts = Merge(ofArray([new AllWebpartFunctions((page, userSession, model) => {
    const page_1 = page;
    const model_1 = model;
    if (page_1 instanceof Page_6) {
        const oldModel = (model_1.PageModel instanceof Model_7) ? model_1.PageModel : undefined;
        const patternInput = Part_6.Init(page_1, userSession, oldModel);
        return [patternInput[0], Cmd_map((x) => (new Msg(1, [x])), patternInput[1])];
    }
    else {
        return undefined;
    }
}, (msg, globalmodel) => {
    const msg_1 = msg;
    const globalmodel_1 = globalmodel;
    if ((globalmodel_1.PageModel instanceof Model_7) && (msg_1 instanceof Msg_7)) {
        const pageModel = globalmodel_1.PageModel;
        const patternInput_1 = Part_6.Update(msg_1, pageModel);
        return [new Model_1(globalmodel_1.Page, patternInput_1[0], globalmodel_1.User, globalmodel_1.VideoOverlayVimeoId, globalmodel_1.MessageBox, globalmodel_1.IsBurgerMenuOpen, globalmodel_1.IsNotificationMenuOpen), Cmd_map((x_1) => (new Msg(1, [x_1])), patternInput_1[1])];
    }
    else {
        return undefined;
    }
}, (model_1_1, dispatch, navigateTo) => {
    const model_2 = model_1_1;
    return (model_2.PageModel instanceof Model_7) ? Part_6.View(model_2.PageModel, (msg_2) => {
        dispatch(new Msg(1, [msg_2]));
    }, navigateTo) : undefined;
}, (model_2_1) => {
    const model_3 = model_2_1;
    return (model_3.PageModel instanceof Model_7) ? Part_6.GetHeader(model_3.PageModel) : undefined;
}, (msg_1_1) => {
    const msg_3 = msg_1_1;
    return (msg_3 instanceof Msg_7) ? Part_6.GetGlobalMsg(msg_3) : undefined;
}, (segments) => map((p) => p, Part_6.ParseUrl(segments)), (page_1_1) => {
    const page_2 = page_1_1;
    return (page_2 instanceof Page_6) ? Part_6.BuildUrl(page_2) : undefined;
}), new AllWebpartFunctions((page_3, userSession_2, model_4) => {
    const page_4 = page_3;
    const model_5 = model_4;
    if (page_4 instanceof Page_7) {
        const oldModel_1 = (model_5.PageModel instanceof Model_8) ? model_5.PageModel : undefined;
        const patternInput_2 = Part_7.Init(page_4, userSession_2, oldModel_1);
        return [patternInput_2[0], Cmd_map((x_2) => (new Msg(1, [x_2])), patternInput_2[1])];
    }
    else {
        return undefined;
    }
}, (msg_4, globalmodel_2) => {
    const msg_5 = msg_4;
    const globalmodel_3 = globalmodel_2;
    if ((globalmodel_3.PageModel instanceof Model_8) && (msg_5 instanceof Msg_8)) {
        const pageModel_1 = globalmodel_3.PageModel;
        const patternInput_3 = Part_7.Update(msg_5, pageModel_1);
        return [new Model_1(globalmodel_3.Page, patternInput_3[0], globalmodel_3.User, globalmodel_3.VideoOverlayVimeoId, globalmodel_3.MessageBox, globalmodel_3.IsBurgerMenuOpen, globalmodel_3.IsNotificationMenuOpen), Cmd_map((x_3) => (new Msg(1, [x_3])), patternInput_3[1])];
    }
    else {
        return undefined;
    }
}, (model_1_3, dispatch_2, navigateTo_2) => {
    const model_6 = model_1_3;
    return (model_6.PageModel instanceof Model_8) ? Part_7.View(model_6.PageModel, (msg_6) => {
        dispatch_2(new Msg(1, [msg_6]));
    }, navigateTo_2) : undefined;
}, (model_2_2) => {
    const model_7 = model_2_2;
    return (model_7.PageModel instanceof Model_8) ? Part_7.GetHeader(model_7.PageModel) : undefined;
}, (msg_1_2) => {
    const msg_7 = msg_1_2;
    return (msg_7 instanceof Msg_8) ? Part_7.GetGlobalMsg(msg_7) : undefined;
}, (segments_2) => map((p_1) => p_1, Part_7.ParseUrl(segments_2)), (page_1_2) => {
    const page_5 = page_1_2;
    return (page_5 instanceof Page_7) ? Part_7.BuildUrl(page_5) : undefined;
}), new AllWebpartFunctions((page_6, userSession_4, model_8) => {
    const page_7 = page_6;
    const model_9 = model_8;
    if (page_7 instanceof Page_8) {
        const oldModel_2 = (model_9.PageModel instanceof Model_9) ? model_9.PageModel : undefined;
        const patternInput_4 = Part_8.Init(page_7, userSession_4, oldModel_2);
        return [patternInput_4[0], Cmd_map((x_4) => (new Msg(1, [x_4])), patternInput_4[1])];
    }
    else {
        return undefined;
    }
}, (msg_8, globalmodel_4) => {
    const msg_9 = msg_8;
    const globalmodel_5 = globalmodel_4;
    if ((globalmodel_5.PageModel instanceof Model_9) && (msg_9 instanceof Msg_9)) {
        const pageModel_2 = globalmodel_5.PageModel;
        const patternInput_5 = Part_8.Update(msg_9, pageModel_2);
        return [new Model_1(globalmodel_5.Page, patternInput_5[0], globalmodel_5.User, globalmodel_5.VideoOverlayVimeoId, globalmodel_5.MessageBox, globalmodel_5.IsBurgerMenuOpen, globalmodel_5.IsNotificationMenuOpen), Cmd_map((x_5) => (new Msg(1, [x_5])), patternInput_5[1])];
    }
    else {
        return undefined;
    }
}, (model_1_5, dispatch_4, navigateTo_4) => {
    const model_10 = model_1_5;
    return (model_10.PageModel instanceof Model_9) ? Part_8.View(model_10.PageModel, (msg_10) => {
        dispatch_4(new Msg(1, [msg_10]));
    }, navigateTo_4) : undefined;
}, (model_2_3) => {
    const model_11 = model_2_3;
    return (model_11.PageModel instanceof Model_9) ? Part_8.GetHeader(model_11.PageModel) : undefined;
}, (msg_1_3) => {
    const msg_11 = msg_1_3;
    return (msg_11 instanceof Msg_9) ? Part_8.GetGlobalMsg(msg_11) : undefined;
}, (segments_4) => map((p_2) => p_2, Part_8.ParseUrl(segments_4)), (page_1_3) => {
    const page_8 = page_1_3;
    return (page_8 instanceof Page_8) ? Part_8.BuildUrl(page_8) : undefined;
}), new AllWebpartFunctions((page_9, userSession_6, model_12) => {
    const page_10 = page_9;
    const model_13 = model_12;
    if (page_10 instanceof Page_9) {
        const oldModel_3 = (model_13.PageModel instanceof Model_10) ? model_13.PageModel : undefined;
        const patternInput_6 = Part_9.Init(page_10, userSession_6, oldModel_3);
        return [patternInput_6[0], Cmd_map((x_6) => (new Msg(1, [x_6])), patternInput_6[1])];
    }
    else {
        return undefined;
    }
}, (msg_12, globalmodel_6) => {
    const msg_13 = msg_12;
    const globalmodel_7 = globalmodel_6;
    if ((globalmodel_7.PageModel instanceof Model_10) && (msg_13 instanceof Msg_10)) {
        const pageModel_3 = globalmodel_7.PageModel;
        const patternInput_7 = Part_9.Update(msg_13, pageModel_3);
        return [new Model_1(globalmodel_7.Page, patternInput_7[0], globalmodel_7.User, globalmodel_7.VideoOverlayVimeoId, globalmodel_7.MessageBox, globalmodel_7.IsBurgerMenuOpen, globalmodel_7.IsNotificationMenuOpen), Cmd_map((x_7) => (new Msg(1, [x_7])), patternInput_7[1])];
    }
    else {
        return undefined;
    }
}, (model_1_7, dispatch_6, navigateTo_6) => {
    const model_14 = model_1_7;
    return (model_14.PageModel instanceof Model_10) ? Part_9.View(model_14.PageModel, (msg_14) => {
        dispatch_6(new Msg(1, [msg_14]));
    }, navigateTo_6) : undefined;
}, (model_2_4) => {
    const model_15 = model_2_4;
    return (model_15.PageModel instanceof Model_10) ? Part_9.GetHeader(model_15.PageModel) : undefined;
}, (msg_1_4) => {
    const msg_15 = msg_1_4;
    return (msg_15 instanceof Msg_10) ? Part_9.GetGlobalMsg(msg_15) : undefined;
}, (segments_6) => map((p_3) => p_3, Part_9.ParseUrl(segments_6)), (page_1_4) => {
    const page_11 = page_1_4;
    return (page_11 instanceof Page_9) ? Part_9.BuildUrl(page_11) : undefined;
}), new AllWebpartFunctions((page_12, userSession_8, model_16) => {
    const page_13 = page_12;
    const model_17 = model_16;
    if (page_13 instanceof Page_10) {
        const oldModel_4 = (model_17.PageModel instanceof Model_11) ? model_17.PageModel : undefined;
        const patternInput_8 = Part_10.Init(page_13, userSession_8, oldModel_4);
        return [patternInput_8[0], Cmd_map((x_8) => (new Msg(1, [x_8])), patternInput_8[1])];
    }
    else {
        return undefined;
    }
}, (msg_16, globalmodel_8) => {
    const msg_17 = msg_16;
    const globalmodel_9 = globalmodel_8;
    if ((globalmodel_9.PageModel instanceof Model_11) && (msg_17 instanceof Msg_11)) {
        const pageModel_4 = globalmodel_9.PageModel;
        const patternInput_9 = Part_10.Update(msg_17, pageModel_4);
        return [new Model_1(globalmodel_9.Page, patternInput_9[0], globalmodel_9.User, globalmodel_9.VideoOverlayVimeoId, globalmodel_9.MessageBox, globalmodel_9.IsBurgerMenuOpen, globalmodel_9.IsNotificationMenuOpen), Cmd_map((x_9) => (new Msg(1, [x_9])), patternInput_9[1])];
    }
    else {
        return undefined;
    }
}, (model_1_9, dispatch_8, navigateTo_8) => {
    const model_18 = model_1_9;
    return (model_18.PageModel instanceof Model_11) ? Part_10.View(model_18.PageModel, (msg_18) => {
        dispatch_8(new Msg(1, [msg_18]));
    }, navigateTo_8) : undefined;
}, (model_2_5) => {
    const model_19 = model_2_5;
    return (model_19.PageModel instanceof Model_11) ? Part_10.GetHeader(model_19.PageModel) : undefined;
}, (msg_1_5) => {
    const msg_19 = msg_1_5;
    return (msg_19 instanceof Msg_11) ? Part_10.GetGlobalMsg(msg_19) : undefined;
}, (segments_8) => map((p_4) => p_4, Part_10.ParseUrl(segments_8)), (page_1_5) => {
    const page_14 = page_1_5;
    return (page_14 instanceof Page_10) ? Part_10.BuildUrl(page_14) : undefined;
}), new AllWebpartFunctions((page_15, userSession_10, model_20) => {
    const page_16 = page_15;
    const model_21 = model_20;
    if (page_16 instanceof Page_11) {
        const oldModel_5 = (model_21.PageModel instanceof Model_12) ? model_21.PageModel : undefined;
        const patternInput_10 = Part_11.Init(page_16, userSession_10, oldModel_5);
        return [patternInput_10[0], Cmd_map((x_10) => (new Msg(1, [x_10])), patternInput_10[1])];
    }
    else {
        return undefined;
    }
}, (msg_20, globalmodel_10) => {
    const msg_21 = msg_20;
    const globalmodel_11 = globalmodel_10;
    if ((globalmodel_11.PageModel instanceof Model_12) && (msg_21 instanceof Msg_12)) {
        const pageModel_5 = globalmodel_11.PageModel;
        const patternInput_11 = Part_11.Update(msg_21, pageModel_5);
        return [new Model_1(globalmodel_11.Page, patternInput_11[0], globalmodel_11.User, globalmodel_11.VideoOverlayVimeoId, globalmodel_11.MessageBox, globalmodel_11.IsBurgerMenuOpen, globalmodel_11.IsNotificationMenuOpen), Cmd_map((x_11) => (new Msg(1, [x_11])), patternInput_11[1])];
    }
    else {
        return undefined;
    }
}, (model_1_11, dispatch_10, navigateTo_10) => {
    const model_22 = model_1_11;
    return (model_22.PageModel instanceof Model_12) ? Part_11.View(model_22.PageModel, (msg_22) => {
        dispatch_10(new Msg(1, [msg_22]));
    }, navigateTo_10) : undefined;
}, (model_2_6) => {
    const model_23 = model_2_6;
    return (model_23.PageModel instanceof Model_12) ? Part_11.GetHeader(model_23.PageModel) : undefined;
}, (msg_1_6) => {
    const msg_23 = msg_1_6;
    return (msg_23 instanceof Msg_12) ? Part_11.GetGlobalMsg(msg_23) : undefined;
}, (segments_10) => map((p_5) => p_5, Part_11.ParseUrl(segments_10)), (page_1_6) => {
    const page_17 = page_1_6;
    return (page_17 instanceof Page_11) ? Part_11.BuildUrl(page_17) : undefined;
}), new AllWebpartFunctions((page_18, userSession_12, model_24) => {
    const page_19 = page_18;
    const model_25 = model_24;
    if (page_19 instanceof Page_12) {
        const oldModel_6 = (model_25.PageModel instanceof Model_13) ? model_25.PageModel : undefined;
        const patternInput_12 = Part_12.Init(page_19, userSession_12, oldModel_6);
        return [patternInput_12[0], Cmd_map((x_12) => (new Msg(1, [x_12])), patternInput_12[1])];
    }
    else {
        return undefined;
    }
}, (msg_24, globalmodel_12) => {
    const msg_25 = msg_24;
    const globalmodel_13 = globalmodel_12;
    if ((globalmodel_13.PageModel instanceof Model_13) && (msg_25 instanceof Msg_13)) {
        const pageModel_6 = globalmodel_13.PageModel;
        const patternInput_13 = Part_12.Update(msg_25, pageModel_6);
        return [new Model_1(globalmodel_13.Page, patternInput_13[0], globalmodel_13.User, globalmodel_13.VideoOverlayVimeoId, globalmodel_13.MessageBox, globalmodel_13.IsBurgerMenuOpen, globalmodel_13.IsNotificationMenuOpen), Cmd_map((x_13) => (new Msg(1, [x_13])), patternInput_13[1])];
    }
    else {
        return undefined;
    }
}, (model_1_13, dispatch_12, navigateTo_12) => {
    const model_26 = model_1_13;
    return (model_26.PageModel instanceof Model_13) ? Part_12.View(model_26.PageModel, (msg_26) => {
        dispatch_12(new Msg(1, [msg_26]));
    }, navigateTo_12) : undefined;
}, (model_2_7) => {
    const model_27 = model_2_7;
    return (model_27.PageModel instanceof Model_13) ? Part_12.GetHeader(model_27.PageModel) : undefined;
}, (msg_1_7) => {
    const msg_27 = msg_1_7;
    return (msg_27 instanceof Msg_13) ? Part_12.GetGlobalMsg(msg_27) : undefined;
}, (segments_12) => map((p_6) => p_6, Part_12.ParseUrl(segments_12)), (page_1_7) => {
    const page_20 = page_1_7;
    return (page_20 instanceof Page_12) ? Part_12.BuildUrl(page_20) : undefined;
}), new AllWebpartFunctions((page_21, userSession_14, model_28) => {
    const page_22 = page_21;
    const model_29 = model_28;
    if (page_22 instanceof Page_13) {
        const oldModel_7 = (model_29.PageModel instanceof Model_14) ? model_29.PageModel : undefined;
        const patternInput_14 = Part_13.Init(page_22, userSession_14, oldModel_7);
        return [patternInput_14[0], Cmd_map((x_14) => (new Msg(1, [x_14])), patternInput_14[1])];
    }
    else {
        return undefined;
    }
}, (msg_28, globalmodel_14) => {
    const msg_29 = msg_28;
    const globalmodel_15 = globalmodel_14;
    if ((globalmodel_15.PageModel instanceof Model_14) && (msg_29 instanceof Msg_14)) {
        const pageModel_7 = globalmodel_15.PageModel;
        const patternInput_15 = Part_13.Update(msg_29, pageModel_7);
        return [new Model_1(globalmodel_15.Page, patternInput_15[0], globalmodel_15.User, globalmodel_15.VideoOverlayVimeoId, globalmodel_15.MessageBox, globalmodel_15.IsBurgerMenuOpen, globalmodel_15.IsNotificationMenuOpen), Cmd_map((x_15) => (new Msg(1, [x_15])), patternInput_15[1])];
    }
    else {
        return undefined;
    }
}, (model_1_15, dispatch_14, navigateTo_14) => {
    const model_30 = model_1_15;
    return (model_30.PageModel instanceof Model_14) ? Part_13.View(model_30.PageModel, (msg_30) => {
        dispatch_14(new Msg(1, [msg_30]));
    }, navigateTo_14) : undefined;
}, (model_2_8) => {
    const model_31 = model_2_8;
    return (model_31.PageModel instanceof Model_14) ? Part_13.GetHeader(model_31.PageModel) : undefined;
}, (msg_1_8) => {
    const msg_31 = msg_1_8;
    return (msg_31 instanceof Msg_14) ? Part_13.GetGlobalMsg(msg_31) : undefined;
}, (segments_14) => map((p_7) => p_7, Part_13.ParseUrl(segments_14)), (page_1_8) => {
    const page_23 = page_1_8;
    return (page_23 instanceof Page_13) ? Part_13.BuildUrl(page_23) : undefined;
}), new AllWebpartFunctions((page_24, userSession_16, model_32) => {
    const page_25 = page_24;
    const model_33 = model_32;
    if (page_25 instanceof Page_14) {
        const oldModel_8 = (model_33.PageModel instanceof Model_15) ? model_33.PageModel : undefined;
        const patternInput_16 = Part_14.Init(page_25, userSession_16, oldModel_8);
        return [patternInput_16[0], Cmd_map((x_16) => (new Msg(1, [x_16])), patternInput_16[1])];
    }
    else {
        return undefined;
    }
}, (msg_32, globalmodel_16) => {
    const msg_33 = msg_32;
    const globalmodel_17 = globalmodel_16;
    if ((globalmodel_17.PageModel instanceof Model_15) && (msg_33 instanceof Msg_15)) {
        const pageModel_8 = globalmodel_17.PageModel;
        const patternInput_17 = Part_14.Update(msg_33, pageModel_8);
        return [new Model_1(globalmodel_17.Page, patternInput_17[0], globalmodel_17.User, globalmodel_17.VideoOverlayVimeoId, globalmodel_17.MessageBox, globalmodel_17.IsBurgerMenuOpen, globalmodel_17.IsNotificationMenuOpen), Cmd_map((x_17) => (new Msg(1, [x_17])), patternInput_17[1])];
    }
    else {
        return undefined;
    }
}, (model_1_17, dispatch_16, navigateTo_16) => {
    const model_34 = model_1_17;
    return (model_34.PageModel instanceof Model_15) ? Part_14.View(model_34.PageModel, (msg_34) => {
        dispatch_16(new Msg(1, [msg_34]));
    }, navigateTo_16) : undefined;
}, (model_2_9) => {
    const model_35 = model_2_9;
    return (model_35.PageModel instanceof Model_15) ? Part_14.GetHeader(model_35.PageModel) : undefined;
}, (msg_1_9) => {
    const msg_35 = msg_1_9;
    return (msg_35 instanceof Msg_15) ? Part_14.GetGlobalMsg(msg_35) : undefined;
}, (segments_16) => map((p_8) => p_8, Part_14.ParseUrl(segments_16)), (page_1_9) => {
    const page_26 = page_1_9;
    return (page_26 instanceof Page_14) ? Part_14.BuildUrl(page_26) : undefined;
}), new AllWebpartFunctions((page_27, userSession_18, model_36) => {
    const page_28 = page_27;
    const model_37 = model_36;
    if (page_28 instanceof Page_15) {
        const oldModel_9 = (model_37.PageModel instanceof Model_16) ? model_37.PageModel : undefined;
        const patternInput_18 = Part_15.Init(page_28, userSession_18, oldModel_9);
        return [patternInput_18[0], Cmd_map((x_18) => (new Msg(1, [x_18])), patternInput_18[1])];
    }
    else {
        return undefined;
    }
}, (msg_36, globalmodel_18) => {
    const msg_37 = msg_36;
    const globalmodel_19 = globalmodel_18;
    if ((globalmodel_19.PageModel instanceof Model_16) && (msg_37 instanceof Msg_16)) {
        const pageModel_9 = globalmodel_19.PageModel;
        const patternInput_19 = Part_15.Update(msg_37, pageModel_9);
        return [new Model_1(globalmodel_19.Page, patternInput_19[0], globalmodel_19.User, globalmodel_19.VideoOverlayVimeoId, globalmodel_19.MessageBox, globalmodel_19.IsBurgerMenuOpen, globalmodel_19.IsNotificationMenuOpen), Cmd_map((x_19) => (new Msg(1, [x_19])), patternInput_19[1])];
    }
    else {
        return undefined;
    }
}, (model_1_19, dispatch_18, navigateTo_18) => {
    const model_38 = model_1_19;
    return (model_38.PageModel instanceof Model_16) ? Part_15.View(model_38.PageModel, (msg_38) => {
        dispatch_18(new Msg(1, [msg_38]));
    }, navigateTo_18) : undefined;
}, (model_2_10) => {
    const model_39 = model_2_10;
    return (model_39.PageModel instanceof Model_16) ? Part_15.GetHeader(model_39.PageModel) : undefined;
}, (msg_1_10) => {
    const msg_39 = msg_1_10;
    return (msg_39 instanceof Msg_16) ? Part_15.GetGlobalMsg(msg_39) : undefined;
}, (segments_18) => map((p_9) => p_9, Part_15.ParseUrl(segments_18)), (page_1_10) => {
    const page_29 = page_1_10;
    return (page_29 instanceof Page_15) ? Part_15.BuildUrl(page_29) : undefined;
}), new AllWebpartFunctions((page_30, userSession_20, model_40) => {
    const page_31 = page_30;
    const model_41 = model_40;
    if (page_31 instanceof DashboardPage) {
        const oldModel_10 = (model_41.PageModel instanceof Model_17) ? model_41.PageModel : undefined;
        const patternInput_20 = Part_16.Init(page_31, userSession_20, oldModel_10);
        return [patternInput_20[0], Cmd_map((x_20) => (new Msg(1, [x_20])), patternInput_20[1])];
    }
    else {
        return undefined;
    }
}, (msg_40, globalmodel_20) => {
    const msg_41 = msg_40;
    const globalmodel_21 = globalmodel_20;
    if ((globalmodel_21.PageModel instanceof Model_17) && (msg_41 instanceof Msg_17)) {
        const pageModel_10 = globalmodel_21.PageModel;
        const patternInput_21 = Part_16.Update(msg_41, pageModel_10);
        return [new Model_1(globalmodel_21.Page, patternInput_21[0], globalmodel_21.User, globalmodel_21.VideoOverlayVimeoId, globalmodel_21.MessageBox, globalmodel_21.IsBurgerMenuOpen, globalmodel_21.IsNotificationMenuOpen), Cmd_map((x_21) => (new Msg(1, [x_21])), patternInput_21[1])];
    }
    else {
        return undefined;
    }
}, (model_1_21, dispatch_20, navigateTo_20) => {
    const model_42 = model_1_21;
    return (model_42.PageModel instanceof Model_17) ? Part_16.View(model_42.PageModel, (msg_42) => {
        dispatch_20(new Msg(1, [msg_42]));
    }, navigateTo_20) : undefined;
}, (model_2_11) => {
    const model_43 = model_2_11;
    return (model_43.PageModel instanceof Model_17) ? Part_16.GetHeader(model_43.PageModel) : undefined;
}, (msg_1_11) => {
    const msg_43 = msg_1_11;
    return (msg_43 instanceof Msg_17) ? Part_16.GetGlobalMsg(msg_43) : undefined;
}, (segments_20) => map((p_10) => p_10, Part_16.ParseUrl(segments_20)), (page_1_11) => {
    const page_32 = page_1_11;
    return (page_32 instanceof DashboardPage) ? Part_16.BuildUrl(page_32) : undefined;
}), new AllWebpartFunctions((page_33, userSession_22, model_44) => {
    const page_34 = page_33;
    const model_45 = model_44;
    if (page_34 instanceof Page_16) {
        const oldModel_11 = (model_45.PageModel instanceof Model_18) ? model_45.PageModel : undefined;
        const patternInput_22 = Part_17.Init(page_34, userSession_22, oldModel_11);
        return [patternInput_22[0], Cmd_map((x_22) => (new Msg(1, [x_22])), patternInput_22[1])];
    }
    else {
        return undefined;
    }
}, (msg_44, globalmodel_22) => {
    const msg_45 = msg_44;
    const globalmodel_23 = globalmodel_22;
    if ((globalmodel_23.PageModel instanceof Model_18) && (msg_45 instanceof Msg_18)) {
        const pageModel_11 = globalmodel_23.PageModel;
        const patternInput_23 = Part_17.Update(msg_45, pageModel_11);
        return [new Model_1(globalmodel_23.Page, patternInput_23[0], globalmodel_23.User, globalmodel_23.VideoOverlayVimeoId, globalmodel_23.MessageBox, globalmodel_23.IsBurgerMenuOpen, globalmodel_23.IsNotificationMenuOpen), Cmd_map((x_23) => (new Msg(1, [x_23])), patternInput_23[1])];
    }
    else {
        return undefined;
    }
}, (model_1_23, dispatch_22, navigateTo_22) => {
    const model_46 = model_1_23;
    return (model_46.PageModel instanceof Model_18) ? Part_17.View(model_46.PageModel, (msg_46) => {
        dispatch_22(new Msg(1, [msg_46]));
    }, navigateTo_22) : undefined;
}, (model_2_12) => {
    const model_47 = model_2_12;
    return (model_47.PageModel instanceof Model_18) ? Part_17.GetHeader(model_47.PageModel) : undefined;
}, (msg_1_12) => {
    const msg_47 = msg_1_12;
    return (msg_47 instanceof Msg_18) ? Part_17.GetGlobalMsg(msg_47) : undefined;
}, (segments_22) => map((p_11) => p_11, Part_17.ParseUrl(segments_22)), (page_1_12) => {
    const page_35 = page_1_12;
    return (page_35 instanceof Page_16) ? Part_17.BuildUrl(page_35) : undefined;
}), new AllWebpartFunctions((page_36, userSession_24, model_48) => {
    const page_37 = page_36;
    const model_49 = model_48;
    if (page_37 instanceof Page_17) {
        const oldModel_12 = (model_49.PageModel instanceof Model_19) ? model_49.PageModel : undefined;
        const patternInput_24 = Part_18.Init(page_37, userSession_24, oldModel_12);
        return [patternInput_24[0], Cmd_map((x_24) => (new Msg(1, [x_24])), patternInput_24[1])];
    }
    else {
        return undefined;
    }
}, (msg_48, globalmodel_24) => {
    const msg_49 = msg_48;
    const globalmodel_25 = globalmodel_24;
    if ((globalmodel_25.PageModel instanceof Model_19) && (msg_49 instanceof Msg_19)) {
        const pageModel_12 = globalmodel_25.PageModel;
        const patternInput_25 = Part_18.Update(msg_49, pageModel_12);
        return [new Model_1(globalmodel_25.Page, patternInput_25[0], globalmodel_25.User, globalmodel_25.VideoOverlayVimeoId, globalmodel_25.MessageBox, globalmodel_25.IsBurgerMenuOpen, globalmodel_25.IsNotificationMenuOpen), Cmd_map((x_25) => (new Msg(1, [x_25])), patternInput_25[1])];
    }
    else {
        return undefined;
    }
}, (model_1_25, dispatch_24, navigateTo_24) => {
    const model_50 = model_1_25;
    return (model_50.PageModel instanceof Model_19) ? Part_18.View(model_50.PageModel, (msg_50) => {
        dispatch_24(new Msg(1, [msg_50]));
    }, navigateTo_24) : undefined;
}, (model_2_13) => {
    const model_51 = model_2_13;
    return (model_51.PageModel instanceof Model_19) ? Part_18.GetHeader(model_51.PageModel) : undefined;
}, (msg_1_13) => {
    const msg_51 = msg_1_13;
    return (msg_51 instanceof Msg_19) ? Part_18.GetGlobalMsg(msg_51) : undefined;
}, (segments_24) => map((p_12) => p_12, Part_18.ParseUrl(segments_24)), (page_1_13) => {
    const page_38 = page_1_13;
    return (page_38 instanceof Page_17) ? Part_18.BuildUrl(page_38) : undefined;
}), new AllWebpartFunctions((page_39, userSession_26, model_52) => {
    const page_40 = page_39;
    const model_53 = model_52;
    if (page_40 instanceof Page_18) {
        const oldModel_13 = (model_53.PageModel instanceof Model_20) ? model_53.PageModel : undefined;
        const patternInput_26 = Part_19.Init(page_40, userSession_26, oldModel_13);
        return [patternInput_26[0], Cmd_map((x_26) => (new Msg(1, [x_26])), patternInput_26[1])];
    }
    else {
        return undefined;
    }
}, (msg_52, globalmodel_26) => {
    const msg_53 = msg_52;
    const globalmodel_27 = globalmodel_26;
    if ((globalmodel_27.PageModel instanceof Model_20) && (msg_53 instanceof Msg_20)) {
        const pageModel_13 = globalmodel_27.PageModel;
        const patternInput_27 = Part_19.Update(msg_53, pageModel_13);
        return [new Model_1(globalmodel_27.Page, patternInput_27[0], globalmodel_27.User, globalmodel_27.VideoOverlayVimeoId, globalmodel_27.MessageBox, globalmodel_27.IsBurgerMenuOpen, globalmodel_27.IsNotificationMenuOpen), Cmd_map((x_27) => (new Msg(1, [x_27])), patternInput_27[1])];
    }
    else {
        return undefined;
    }
}, (model_1_27, dispatch_26, navigateTo_26) => {
    const model_54 = model_1_27;
    return (model_54.PageModel instanceof Model_20) ? Part_19.View(model_54.PageModel, (msg_54) => {
        dispatch_26(new Msg(1, [msg_54]));
    }, navigateTo_26) : undefined;
}, (model_2_14) => {
    const model_55 = model_2_14;
    return (model_55.PageModel instanceof Model_20) ? Part_19.GetHeader(model_55.PageModel) : undefined;
}, (msg_1_14) => {
    const msg_55 = msg_1_14;
    return (msg_55 instanceof Msg_20) ? Part_19.GetGlobalMsg(msg_55) : undefined;
}, (segments_26) => map((p_13) => p_13, Part_19.ParseUrl(segments_26)), (page_1_14) => {
    const page_41 = page_1_14;
    return (page_41 instanceof Page_18) ? Part_19.BuildUrl(page_41) : undefined;
}), new AllWebpartFunctions((page_42, userSession_28, model_56) => {
    const page_43 = page_42;
    const model_57 = model_56;
    if (page_43 instanceof Page_19) {
        const oldModel_14 = (model_57.PageModel instanceof Model_21) ? model_57.PageModel : undefined;
        const patternInput_28 = Part_20.Init(page_43, userSession_28, oldModel_14);
        return [patternInput_28[0], Cmd_map((x_28) => (new Msg(1, [x_28])), patternInput_28[1])];
    }
    else {
        return undefined;
    }
}, (msg_56, globalmodel_28) => {
    const msg_57 = msg_56;
    const globalmodel_29 = globalmodel_28;
    if ((globalmodel_29.PageModel instanceof Model_21) && (msg_57 instanceof Msg_21)) {
        const pageModel_14 = globalmodel_29.PageModel;
        const patternInput_29 = Part_20.Update(msg_57, pageModel_14);
        return [new Model_1(globalmodel_29.Page, patternInput_29[0], globalmodel_29.User, globalmodel_29.VideoOverlayVimeoId, globalmodel_29.MessageBox, globalmodel_29.IsBurgerMenuOpen, globalmodel_29.IsNotificationMenuOpen), Cmd_map((x_29) => (new Msg(1, [x_29])), patternInput_29[1])];
    }
    else {
        return undefined;
    }
}, (model_1_29, dispatch_28, navigateTo_28) => {
    const model_58 = model_1_29;
    return (model_58.PageModel instanceof Model_21) ? Part_20.View(model_58.PageModel, (msg_58) => {
        dispatch_28(new Msg(1, [msg_58]));
    }, navigateTo_28) : undefined;
}, (model_2_15) => {
    const model_59 = model_2_15;
    return (model_59.PageModel instanceof Model_21) ? Part_20.GetHeader(model_59.PageModel) : undefined;
}, (msg_1_15) => {
    const msg_59 = msg_1_15;
    return (msg_59 instanceof Msg_21) ? Part_20.GetGlobalMsg(msg_59) : undefined;
}, (segments_28) => map((p_14) => p_14, Part_20.ParseUrl(segments_28)), (page_1_15) => {
    const page_44 = page_1_15;
    return (page_44 instanceof Page_19) ? Part_20.BuildUrl(page_44) : undefined;
}), new AllWebpartFunctions((page_45, userSession_30, model_60) => {
    const page_46 = page_45;
    const model_61 = model_60;
    if (page_46 instanceof Page_20) {
        const oldModel_15 = (model_61.PageModel instanceof Model_22) ? model_61.PageModel : undefined;
        const patternInput_30 = Part_21.Init(page_46, userSession_30, oldModel_15);
        return [patternInput_30[0], Cmd_map((x_30) => (new Msg(1, [x_30])), patternInput_30[1])];
    }
    else {
        return undefined;
    }
}, (msg_60, globalmodel_30) => {
    const msg_61 = msg_60;
    const globalmodel_31 = globalmodel_30;
    if ((globalmodel_31.PageModel instanceof Model_22) && (msg_61 instanceof Msg_22)) {
        const pageModel_15 = globalmodel_31.PageModel;
        const patternInput_31 = Part_21.Update(msg_61, pageModel_15);
        return [new Model_1(globalmodel_31.Page, patternInput_31[0], globalmodel_31.User, globalmodel_31.VideoOverlayVimeoId, globalmodel_31.MessageBox, globalmodel_31.IsBurgerMenuOpen, globalmodel_31.IsNotificationMenuOpen), Cmd_map((x_31) => (new Msg(1, [x_31])), patternInput_31[1])];
    }
    else {
        return undefined;
    }
}, (model_1_31, dispatch_30, navigateTo_30) => {
    const model_62 = model_1_31;
    return (model_62.PageModel instanceof Model_22) ? Part_21.View(model_62.PageModel, (msg_62) => {
        dispatch_30(new Msg(1, [msg_62]));
    }, navigateTo_30) : undefined;
}, (model_2_16) => {
    const model_63 = model_2_16;
    return (model_63.PageModel instanceof Model_22) ? Part_21.GetHeader(model_63.PageModel) : undefined;
}, (msg_1_16) => {
    const msg_63 = msg_1_16;
    return (msg_63 instanceof Msg_22) ? Part_21.GetGlobalMsg(msg_63) : undefined;
}, (segments_30) => map((p_15) => p_15, Part_21.ParseUrl(segments_30)), (page_1_16) => {
    const page_47 = page_1_16;
    return (page_47 instanceof Page_20) ? Part_21.BuildUrl(page_47) : undefined;
}), new AllWebpartFunctions((page_48, userSession_32, model_64) => {
    const page_49 = page_48;
    const model_65 = model_64;
    if (page_49 instanceof Page_21) {
        const oldModel_16 = (model_65.PageModel instanceof Model_23) ? model_65.PageModel : undefined;
        const patternInput_32 = Part_22.Init(page_49, userSession_32, oldModel_16);
        return [patternInput_32[0], Cmd_map((x_32) => (new Msg(1, [x_32])), patternInput_32[1])];
    }
    else {
        return undefined;
    }
}, (msg_64, globalmodel_32) => {
    const msg_65 = msg_64;
    const globalmodel_33 = globalmodel_32;
    if ((globalmodel_33.PageModel instanceof Model_23) && (msg_65 instanceof Msg_23)) {
        const pageModel_16 = globalmodel_33.PageModel;
        const patternInput_33 = Part_22.Update(msg_65, pageModel_16);
        return [new Model_1(globalmodel_33.Page, patternInput_33[0], globalmodel_33.User, globalmodel_33.VideoOverlayVimeoId, globalmodel_33.MessageBox, globalmodel_33.IsBurgerMenuOpen, globalmodel_33.IsNotificationMenuOpen), Cmd_map((x_33) => (new Msg(1, [x_33])), patternInput_33[1])];
    }
    else {
        return undefined;
    }
}, (model_1_33, dispatch_32, navigateTo_32) => {
    const model_66 = model_1_33;
    return (model_66.PageModel instanceof Model_23) ? Part_22.View(model_66.PageModel, (msg_66) => {
        dispatch_32(new Msg(1, [msg_66]));
    }, navigateTo_32) : undefined;
}, (model_2_17) => {
    const model_67 = model_2_17;
    return (model_67.PageModel instanceof Model_23) ? Part_22.GetHeader(model_67.PageModel) : undefined;
}, (msg_1_17) => {
    const msg_67 = msg_1_17;
    return (msg_67 instanceof Msg_23) ? Part_22.GetGlobalMsg(msg_67) : undefined;
}, (segments_32) => map((p_16) => p_16, Part_22.ParseUrl(segments_32)), (page_1_17) => {
    const page_50 = page_1_17;
    return (page_50 instanceof Page_21) ? Part_22.BuildUrl(page_50) : undefined;
}), (() => {
    const webpart_136 = Part_23();
    return new AllWebpartFunctions((page_51, userSession_34, model_68) => {
        const page_52 = page_51;
        const model_69 = model_68;
        if (page_52 instanceof Page_22) {
            const oldModel_17 = (model_69.PageModel instanceof Model_24) ? model_69.PageModel : undefined;
            const patternInput_34 = webpart_136.Init(page_52, userSession_34, oldModel_17);
            return [patternInput_34[0], Cmd_map((x_34) => (new Msg(1, [x_34])), patternInput_34[1])];
        }
        else {
            return undefined;
        }
    }, (msg_68, globalmodel_34) => {
        const msg_69 = msg_68;
        const globalmodel_35 = globalmodel_34;
        if (globalmodel_35.PageModel instanceof Model_24) {
            const pageModel_17 = globalmodel_35.PageModel;
            const patternInput_35 = webpart_136.Update(msg_69, pageModel_17);
            return [new Model_1(globalmodel_35.Page, patternInput_35[0], globalmodel_35.User, globalmodel_35.VideoOverlayVimeoId, globalmodel_35.MessageBox, globalmodel_35.IsBurgerMenuOpen, globalmodel_35.IsNotificationMenuOpen), Cmd_map((x_35) => (new Msg(1, [x_35])), patternInput_35[1])];
        }
        else {
            return undefined;
        }
    }, (model_1_35, dispatch_34, navigateTo_34) => {
        const model_70 = model_1_35;
        return (model_70.PageModel instanceof Model_24) ? webpart_136.View(model_70.PageModel, (msg_70) => {
            dispatch_34(new Msg(1, [msg_70]));
        }, navigateTo_34) : undefined;
    }, (model_2_18) => {
        const model_71 = model_2_18;
        return (model_71.PageModel instanceof Model_24) ? webpart_136.GetHeader(model_71.PageModel) : undefined;
    }, (msg_1_18) => {
        const msg_71 = msg_1_18;
        return webpart_136.GetGlobalMsg(msg_71);
    }, (segments_34) => map((p_17) => p_17, webpart_136.ParseUrl(segments_34)), (page_1_18) => {
        const page_53 = page_1_18;
        return (page_53 instanceof Page_22) ? webpart_136.BuildUrl(page_53) : undefined;
    });
})(), new AllWebpartFunctions((page_54, userSession_36, model_72) => {
    const page_55 = page_54;
    const model_73 = model_72;
    if (page_55 instanceof Page_23) {
        const oldModel_18 = (model_73.PageModel instanceof Model_25) ? model_73.PageModel : undefined;
        const patternInput_36 = Part_24.Init(page_55, userSession_36, oldModel_18);
        return [patternInput_36[0], Cmd_map((x_36) => (new Msg(1, [x_36])), patternInput_36[1])];
    }
    else {
        return undefined;
    }
}, (msg_72, globalmodel_36) => {
    const msg_73 = msg_72;
    const globalmodel_37 = globalmodel_36;
    if ((globalmodel_37.PageModel instanceof Model_25) && (msg_73 instanceof Msg_24)) {
        const pageModel_18 = globalmodel_37.PageModel;
        const patternInput_37 = Part_24.Update(msg_73, pageModel_18);
        return [new Model_1(globalmodel_37.Page, patternInput_37[0], globalmodel_37.User, globalmodel_37.VideoOverlayVimeoId, globalmodel_37.MessageBox, globalmodel_37.IsBurgerMenuOpen, globalmodel_37.IsNotificationMenuOpen), Cmd_map((x_37) => (new Msg(1, [x_37])), patternInput_37[1])];
    }
    else {
        return undefined;
    }
}, (model_1_37, dispatch_36, navigateTo_36) => {
    const model_74 = model_1_37;
    return (model_74.PageModel instanceof Model_25) ? Part_24.View(model_74.PageModel, (msg_74) => {
        dispatch_36(new Msg(1, [msg_74]));
    }, navigateTo_36) : undefined;
}, (model_2_19) => {
    const model_75 = model_2_19;
    return (model_75.PageModel instanceof Model_25) ? Part_24.GetHeader(model_75.PageModel) : undefined;
}, (msg_1_19) => {
    const msg_75 = msg_1_19;
    return (msg_75 instanceof Msg_24) ? Part_24.GetGlobalMsg(msg_75) : undefined;
}, (segments_36) => map((p_18) => p_18, Part_24.ParseUrl(segments_36)), (page_1_19) => {
    const page_56 = page_1_19;
    return (page_56 instanceof Page_23) ? Part_24.BuildUrl(page_56) : undefined;
})]));

export const AllParts = Merge(ofArray([new AllWebpartFunctions((page, userSession, model) => {
    const page_1 = page;
    const model_1 = model;
    if (page_1 instanceof Page_24) {
        const oldModel = (model_1.PageModel instanceof Model_26) ? model_1.PageModel : undefined;
        const patternInput = Part_25.Init(page_1, userSession, oldModel);
        return [patternInput[0], Cmd_map((x) => (new Msg(1, [x])), patternInput[1])];
    }
    else {
        return undefined;
    }
}, (msg, globalmodel) => {
    const msg_1 = msg;
    const globalmodel_1 = globalmodel;
    if ((globalmodel_1.PageModel instanceof Model_26) && (msg_1 instanceof Msg_25)) {
        const pageModel = globalmodel_1.PageModel;
        const patternInput_1 = Part_25.Update(msg_1, pageModel);
        return [new Model_1(globalmodel_1.Page, patternInput_1[0], globalmodel_1.User, globalmodel_1.VideoOverlayVimeoId, globalmodel_1.MessageBox, globalmodel_1.IsBurgerMenuOpen, globalmodel_1.IsNotificationMenuOpen), Cmd_map((x_1) => (new Msg(1, [x_1])), patternInput_1[1])];
    }
    else {
        return undefined;
    }
}, (model_1_1, dispatch, navigateTo) => {
    const model_2 = model_1_1;
    return (model_2.PageModel instanceof Model_26) ? Part_25.View(model_2.PageModel, (msg_2) => {
        dispatch(new Msg(1, [msg_2]));
    }, navigateTo) : undefined;
}, (model_2_1) => {
    const model_3 = model_2_1;
    return (model_3.PageModel instanceof Model_26) ? Part_25.GetHeader(model_3.PageModel) : undefined;
}, (msg_1_1) => {
    const msg_3 = msg_1_1;
    return (msg_3 instanceof Msg_25) ? Part_25.GetGlobalMsg(msg_3) : undefined;
}, (segments) => map((p) => p, Part_25.ParseUrl(segments)), (page_1_1) => {
    const page_2 = page_1_1;
    return (page_2 instanceof Page_24) ? Part_25.BuildUrl(page_2) : undefined;
}), new AllWebpartFunctions((page_3, userSession_2, model_4) => {
    const page_4 = page_3;
    const model_5 = model_4;
    if (page_4 instanceof Page_25) {
        const oldModel_1 = (model_5.PageModel instanceof Model_27) ? model_5.PageModel : undefined;
        const patternInput_2 = Part_26.Init(page_4, userSession_2, oldModel_1);
        return [patternInput_2[0], Cmd_map((x_2) => (new Msg(1, [x_2])), patternInput_2[1])];
    }
    else {
        return undefined;
    }
}, (msg_4, globalmodel_2) => {
    const msg_5 = msg_4;
    const globalmodel_3 = globalmodel_2;
    if ((globalmodel_3.PageModel instanceof Model_27) && (msg_5 instanceof Msg_26)) {
        const pageModel_1 = globalmodel_3.PageModel;
        const patternInput_3 = Part_26.Update(msg_5, pageModel_1);
        return [new Model_1(globalmodel_3.Page, patternInput_3[0], globalmodel_3.User, globalmodel_3.VideoOverlayVimeoId, globalmodel_3.MessageBox, globalmodel_3.IsBurgerMenuOpen, globalmodel_3.IsNotificationMenuOpen), Cmd_map((x_3) => (new Msg(1, [x_3])), patternInput_3[1])];
    }
    else {
        return undefined;
    }
}, (model_1_3, dispatch_2, navigateTo_2) => {
    const model_6 = model_1_3;
    return (model_6.PageModel instanceof Model_27) ? Part_26.View(model_6.PageModel, (msg_6) => {
        dispatch_2(new Msg(1, [msg_6]));
    }, navigateTo_2) : undefined;
}, (model_2_2) => {
    const model_7 = model_2_2;
    return (model_7.PageModel instanceof Model_27) ? Part_26.GetHeader(model_7.PageModel) : undefined;
}, (msg_1_2) => {
    const msg_7 = msg_1_2;
    return (msg_7 instanceof Msg_26) ? Part_26.GetGlobalMsg(msg_7) : undefined;
}, (segments_2) => map((p_1) => p_1, Part_26.ParseUrl(segments_2)), (page_1_2) => {
    const page_5 = page_1_2;
    return (page_5 instanceof Page_25) ? Part_26.BuildUrl(page_5) : undefined;
}), new AllWebpartFunctions((page_6, userSession_4, model_8) => {
    const page_7 = page_6;
    const model_9 = model_8;
    if (page_7 instanceof Page_26) {
        const oldModel_2 = (model_9.PageModel instanceof Model_28) ? model_9.PageModel : undefined;
        const patternInput_4 = Part_27.Init(page_7, userSession_4, oldModel_2);
        return [patternInput_4[0], Cmd_map((x_4) => (new Msg(1, [x_4])), patternInput_4[1])];
    }
    else {
        return undefined;
    }
}, (msg_8, globalmodel_4) => {
    const msg_9 = msg_8;
    const globalmodel_5 = globalmodel_4;
    if ((globalmodel_5.PageModel instanceof Model_28) && (msg_9 instanceof Msg_27)) {
        const pageModel_2 = globalmodel_5.PageModel;
        const patternInput_5 = Part_27.Update(msg_9, pageModel_2);
        return [new Model_1(globalmodel_5.Page, patternInput_5[0], globalmodel_5.User, globalmodel_5.VideoOverlayVimeoId, globalmodel_5.MessageBox, globalmodel_5.IsBurgerMenuOpen, globalmodel_5.IsNotificationMenuOpen), Cmd_map((x_5) => (new Msg(1, [x_5])), patternInput_5[1])];
    }
    else {
        return undefined;
    }
}, (model_1_5, dispatch_4, navigateTo_4) => {
    const model_10 = model_1_5;
    return (model_10.PageModel instanceof Model_28) ? Part_27.View(model_10.PageModel, (msg_10) => {
        dispatch_4(new Msg(1, [msg_10]));
    }, navigateTo_4) : undefined;
}, (model_2_3) => {
    const model_11 = model_2_3;
    return (model_11.PageModel instanceof Model_28) ? Part_27.GetHeader(model_11.PageModel) : undefined;
}, (msg_1_3) => {
    const msg_11 = msg_1_3;
    return (msg_11 instanceof Msg_27) ? Part_27.GetGlobalMsg(msg_11) : undefined;
}, (segments_4) => map((p_2) => p_2, Part_27.ParseUrl(segments_4)), (page_1_3) => {
    const page_8 = page_1_3;
    return (page_8 instanceof Page_26) ? Part_27.BuildUrl(page_8) : undefined;
}), new AllWebpartFunctions((page_9, userSession_6, model_12) => {
    const page_10 = page_9;
    const model_13 = model_12;
    if (page_10 instanceof Page_27) {
        const oldModel_3 = (model_13.PageModel instanceof Model_29) ? model_13.PageModel : undefined;
        const patternInput_6 = Part_28.Init(page_10, userSession_6, oldModel_3);
        return [patternInput_6[0], Cmd_map((x_6) => (new Msg(1, [x_6])), patternInput_6[1])];
    }
    else {
        return undefined;
    }
}, (msg_12, globalmodel_6) => {
    const msg_13 = msg_12;
    const globalmodel_7 = globalmodel_6;
    if ((globalmodel_7.PageModel instanceof Model_29) && (msg_13 instanceof Msg_28)) {
        const pageModel_3 = globalmodel_7.PageModel;
        const patternInput_7 = Part_28.Update(msg_13, pageModel_3);
        return [new Model_1(globalmodel_7.Page, patternInput_7[0], globalmodel_7.User, globalmodel_7.VideoOverlayVimeoId, globalmodel_7.MessageBox, globalmodel_7.IsBurgerMenuOpen, globalmodel_7.IsNotificationMenuOpen), Cmd_map((x_7) => (new Msg(1, [x_7])), patternInput_7[1])];
    }
    else {
        return undefined;
    }
}, (model_1_7, dispatch_6, navigateTo_6) => {
    const model_14 = model_1_7;
    return (model_14.PageModel instanceof Model_29) ? Part_28.View(model_14.PageModel, (msg_14) => {
        dispatch_6(new Msg(1, [msg_14]));
    }, navigateTo_6) : undefined;
}, (model_2_4) => {
    const model_15 = model_2_4;
    return (model_15.PageModel instanceof Model_29) ? Part_28.GetHeader(model_15.PageModel) : undefined;
}, (msg_1_4) => {
    const msg_15 = msg_1_4;
    return (msg_15 instanceof Msg_28) ? Part_28.GetGlobalMsg(msg_15) : undefined;
}, (segments_6) => map((p_3) => p_3, Part_28.ParseUrl(segments_6)), (page_1_4) => {
    const page_11 = page_1_4;
    return (page_11 instanceof Page_27) ? Part_28.BuildUrl(page_11) : undefined;
}), new AllWebpartFunctions((page_12, userSession_8, model_16) => {
    const page_13 = page_12;
    const model_17 = model_16;
    if (page_13 instanceof Page_28) {
        const oldModel_4 = (model_17.PageModel instanceof Model_30) ? model_17.PageModel : undefined;
        const patternInput_8 = Part_29.Init(page_13, userSession_8, oldModel_4);
        return [patternInput_8[0], Cmd_map((x_8) => (new Msg(1, [x_8])), patternInput_8[1])];
    }
    else {
        return undefined;
    }
}, (msg_16, globalmodel_8) => {
    const msg_17 = msg_16;
    const globalmodel_9 = globalmodel_8;
    if ((globalmodel_9.PageModel instanceof Model_30) && (msg_17 instanceof Msg_29)) {
        const pageModel_4 = globalmodel_9.PageModel;
        const patternInput_9 = Part_29.Update(msg_17, pageModel_4);
        return [new Model_1(globalmodel_9.Page, patternInput_9[0], globalmodel_9.User, globalmodel_9.VideoOverlayVimeoId, globalmodel_9.MessageBox, globalmodel_9.IsBurgerMenuOpen, globalmodel_9.IsNotificationMenuOpen), Cmd_map((x_9) => (new Msg(1, [x_9])), patternInput_9[1])];
    }
    else {
        return undefined;
    }
}, (model_1_9, dispatch_8, navigateTo_8) => {
    const model_18 = model_1_9;
    return (model_18.PageModel instanceof Model_30) ? Part_29.View(model_18.PageModel, (msg_18) => {
        dispatch_8(new Msg(1, [msg_18]));
    }, navigateTo_8) : undefined;
}, (model_2_5) => {
    const model_19 = model_2_5;
    return (model_19.PageModel instanceof Model_30) ? Part_29.GetHeader(model_19.PageModel) : undefined;
}, (msg_1_5) => {
    const msg_19 = msg_1_5;
    return (msg_19 instanceof Msg_29) ? Part_29.GetGlobalMsg(msg_19) : undefined;
}, (segments_8) => map((p_4) => p_4, Part_29.ParseUrl(segments_8)), (page_1_5) => {
    const page_14 = page_1_5;
    return (page_14 instanceof Page_28) ? Part_29.BuildUrl(page_14) : undefined;
}), new AllWebpartFunctions((page_15, userSession_10, model_20) => {
    const page_16 = page_15;
    const model_21 = model_20;
    if (page_16 instanceof Page_29) {
        const oldModel_5 = (model_21.PageModel instanceof Model_31) ? model_21.PageModel : undefined;
        const patternInput_10 = Part_30.Init(page_16, userSession_10, oldModel_5);
        return [patternInput_10[0], Cmd_map((x_10) => (new Msg(1, [x_10])), patternInput_10[1])];
    }
    else {
        return undefined;
    }
}, (msg_20, globalmodel_10) => {
    const msg_21 = msg_20;
    const globalmodel_11 = globalmodel_10;
    if ((globalmodel_11.PageModel instanceof Model_31) && (msg_21 instanceof Msg_30)) {
        const pageModel_5 = globalmodel_11.PageModel;
        const patternInput_11 = Part_30.Update(msg_21, pageModel_5);
        return [new Model_1(globalmodel_11.Page, patternInput_11[0], globalmodel_11.User, globalmodel_11.VideoOverlayVimeoId, globalmodel_11.MessageBox, globalmodel_11.IsBurgerMenuOpen, globalmodel_11.IsNotificationMenuOpen), Cmd_map((x_11) => (new Msg(1, [x_11])), patternInput_11[1])];
    }
    else {
        return undefined;
    }
}, (model_1_11, dispatch_10, navigateTo_10) => {
    const model_22 = model_1_11;
    return (model_22.PageModel instanceof Model_31) ? Part_30.View(model_22.PageModel, (msg_22) => {
        dispatch_10(new Msg(1, [msg_22]));
    }, navigateTo_10) : undefined;
}, (model_2_6) => {
    const model_23 = model_2_6;
    return (model_23.PageModel instanceof Model_31) ? Part_30.GetHeader(model_23.PageModel) : undefined;
}, (msg_1_6) => {
    const msg_23 = msg_1_6;
    return (msg_23 instanceof Msg_30) ? Part_30.GetGlobalMsg(msg_23) : undefined;
}, (segments_10) => map((p_5) => p_5, Part_30.ParseUrl(segments_10)), (page_1_6) => {
    const page_17 = page_1_6;
    return (page_17 instanceof Page_29) ? Part_30.BuildUrl(page_17) : undefined;
}), AllUserParts, AllAdminParts]));

//# sourceMappingURL=WebPartRegistry.fs.js.map
